function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg03D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.535,
    height: 19.935,
    viewBox: "0 0 35.535 19.935",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "03d"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14407",
    d: "M77.546 65.723a5.226 5.226 0 0 0-5.16-4.042 5.37 5.37 0 0 0-3.286 1.112 9.351 9.351 0 0 0-8.355-5 9.2 9.2 0 0 0-9.235 7.82 6.211 6.211 0 0 0-4.98 5.98 6.274 6.274 0 0 0 6.37 6.131h22.8a6.273 6.273 0 0 0 6.371-6.133 6.19 6.19 0 0 0-4.525-5.868z",
    style: {
      fill: "#d32f2f"
    },
    transform: "translate(-46.531 -57.789)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184445"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14408",
    d: "M70.843 65.23a7.386 7.386 0 0 1 5.983-3.194.443.443 0 0 0 0-.885 8.321 8.321 0 0 0-6.747 3.631c-.328.467.439.91.764.447z",
    transform: "translate(-62.638 -60.096)",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 184446"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14409",
    d: "M51.184 92.244a4.807 4.807 0 0 1 2.254-4.005c.478-.306.035-1.072-.446-.764a5.722 5.722 0 0 0-2.692 4.769.443.443 0 0 0 .885 0z",
    transform: "translate(-49.117 -78.114)",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg03D);
export default __webpack_public_path__ + "static/media/03D.3dee043ed0c9098e51d5f9ca84fa235d.svg";
export { ForwardRef as ReactComponent };